import {inject, Injectable, NgZone} from '@angular/core';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

interface Shortcut {
  key: string;
  ctrl: boolean;
  shift: boolean;
  alt: boolean;
  callbacks: (() => void)[];
  priority?: number;
}

@Injectable({ providedIn: 'root' })
export class Llm_ShortcutService {
  //Injectbales
  private _console = inject(Tools_aiConsoleService);
  private shortcuts: Shortcut[] = [];

  constructor(private ngZone: NgZone) {
    document.addEventListener('keydown', (event) => this.handleKeyDown(event));
  }

  registerShortcut(keyCombination: string, callbacks: (() => void)[], priority = 0): () => void {
    const parsed = this.parseKeyCombination(keyCombination);
    const shortcut: Shortcut = { ...parsed, callbacks, priority };
    this.shortcuts.push(shortcut);

    return () => {
      this.shortcuts = this.shortcuts.filter(s => s !== shortcut);
    };
  }

  private parseKeyCombination(keyCombination: string): Omit<Shortcut, 'callbacks' | 'priority'> {
    const parts = keyCombination.toLowerCase().split('+').map(p => p.trim());
    let ctrl = false, shift = false, alt = false;
    let key = '';

    parts.forEach(part => {
      switch(part) {
        case 'ctrl': ctrl = true; break;
        case 'shift': shift = true; break;
        case 'alt': alt = true; break;
        default: key = part;
      }
    });

    if (!key) {
      throw new Error(`Combination invalid: ${keyCombination}`);
    }

    return { key, ctrl, shift, alt };
  }

  private handleKeyDown(event: KeyboardEvent): void {
    const activeElement = document.activeElement;
    const isEditable = activeElement?.tagName === 'INPUT'
      || activeElement?.tagName === 'TEXTAREA';
      //|| activeElement?.isContentEditable;

    if (isEditable) return;

    this.ngZone.run(() => {
      const currentKey = event.key.toLowerCase();

      // Filtrar y ordenar por prioridad
      const matchedShortcuts = this.shortcuts
        .filter(shortcut => {
          return shortcut.key === currentKey &&
            shortcut.ctrl === event.ctrlKey &&
            shortcut.shift === event.shiftKey &&
            shortcut.alt === event.altKey;
        })
        .sort((a, b) => (b.priority || 0) - (a.priority || 0));

      if (matchedShortcuts.length > 0) {
        event.preventDefault();
        matchedShortcuts.forEach(shortcut => {
          shortcut.callbacks.forEach(callback => callback());
        });
      }
    });
  }
}
